const baseUrl = '/api/v2/auth';
/** Вход — только ЭЦП (подписанный одноразовый XML) или eGov Mobile (QR). */
export default ($axios) => {
    return {
        login_using_xml(form){
            return $axios.post(`${baseUrl}/xml-login`,form)
        },
        egov_start(){
            return $axios.post(`${baseUrl}/egov`)
        },
        egov_status(token){
            return $axios.get(`${baseUrl}/egov/${token}`)
        },
        get_current_user(){
            return $axios.get(`${baseUrl}/me`)
        }
    };
};
